import moment from 'moment'
import 'moment/locale/cs'

const sdiak = 'áäčďéěíĺľňóô öŕšťúů üýřžÁÄČĎÉĚÍĹĽŇÓÔ ÖŔŠŤÚŮ ÜÝŘŽ'
const bdiak = 'aacdeeillnoo orstuu uyrzAACDEEILLNOO ORSTUU UYRZ'

export default {
  date: (input) => moment(input).format('L LT'),

  filename (input) {
    for (let i = 0; i < sdiak.length; i++) {
      input = input.replace(new RegExp(sdiak[i]), bdiak[i])
    }
    return input
  },

  fileSize (bytes) {
    let u = 0
    let s = 1024
    while (bytes >= s || -bytes >= s) {
      bytes /= s
      u++
    }
    return (u ? bytes.toFixed(1) + ' ' : bytes) + ' KMGTPEZY'[u] + (u ? 'i' : '') + 'B'
  },

  ratio (value, total) {
    if (total !== undefined) {
      if (total === 0) {
        value = 0
      } else {
        value /= total
      }
    }

    value = value || 0

    return Math.round(value * 1E3) / 10 + ' %'
  },

  interval (interval) {
    return ('00' + Math.floor(interval / 3600)).slice(-2) + ':' +
      ('00' + Math.floor((interval % 3600) / 60)).slice(-2) + ':' +
      ('00' + (interval % 60)).slice(-2)
  },

  install (Vue) {
    Vue.prototype.$format = this
  }
}



// WEBPACK FOOTER //
// ./src/utils/Format.js